import {
  Component,
  EventEmitter,
  Input,
  Output,
  PipeTransform,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss'],
})
export class SelectorComponent {
  formGroup: UntypedFormGroup;

  @Input()
  public options: string[];
  @Input()
  public title: string;
  @Input()
  public subtitle: string;
  @Input()
  public subtitleWidth: string;
  @Input()
  public answer: string;
  @Input()
  public optionPipe: PipeTransform;
  @Input()
  public disabled = false;
  @Input()
  public optionValueGetter: (option: any) => string = (option: any) => {
    return option;
  };
  @Input()
  public compareWith: (o1: any, o2: any) => boolean = (o1: any, o2) => {
    return o1 == o2;
  };

  @Output()
  public answerChange = new EventEmitter();

  constructor() {}

  answered(value) {
    this.answerChange.emit(value);
  }

  getSubtitleWidth() {
    return this.subtitleWidth == null ? {} : { width: this.subtitleWidth };
  }
}
